import {createReducer} from "redux-act";
import {
	IEventPlayer,
	IPlayer,
	IPlayerStatsByEvent,
	requestAllPlayersJSONSuccess,
	requestPlayersJSONSuccess,
	requestPlayerStatsJSONSuccess,
} from "modules/actions";

interface IReducer {
	players: IPlayer[];
	playersByEventID: Record<number, IEventPlayer[]>;
	statsByPlayerID: Record<number, Record<number, IPlayerStatsByEvent>>;
}

const defaultState: IReducer = {
	players: [],
	playersByEventID: {},
	statsByPlayerID: {},
};

export const players = createReducer<typeof defaultState>({}, defaultState)
	.on(requestPlayersJSONSuccess, (state, {players, eventID}) => ({
		...state,
		playersByEventID: {
			...state.playersByEventID,
			[eventID]: players,
		},
	}))
	.on(requestPlayerStatsJSONSuccess, (state, {playerID, stats}) => ({
		...state,
		statsByPlayerID: {
			...state.statsByPlayerID,
			[playerID]: stats,
		},
	}))
	.on(requestAllPlayersJSONSuccess, (state, players) => ({
		...state,
		players,
	}));
